import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import { MonacoJsonEditor } from 'src/components/monaco-json-editor';

export function RHFJsonTextarea({ name, label, helperText, minRows = 4 }) {
  const { control } = useFormContext();
  const [hasError, setHasError] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const value =
          typeof field.value === 'object' && field.value !== null
            ? JSON.stringify(field.value, null, 2)
            : (field.value ?? '');

        return (
          <Stack spacing={0.75}>
            {label && (
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {label}
              </Typography>
            )}

            <MonacoJsonEditor
              value={value}
              height={`${Math.max(minRows, 4) * 19}px`}
              onChange={(val) => {
                field.onChange(val);
                try {
                  const parsed = JSON.parse(val);
                  setHasError(parsed === null);
                } catch {
                  setHasError(true);
                }
              }}
            />

            {(error?.message || helperText) && (
              <FormHelperText error={!!error}>{error?.message ?? helperText}</FormHelperText>
            )}
            {hasError && field?.value && (
              <FormHelperText error>JSON is not correct</FormHelperText>
            )}
          </Stack>
        );
      }}
    />
  );
}
